import { gql, useMutation } from '@apollo/client';
import { maybeRestErrorMessage } from 'modules/campaigns/editor/utils';
import { DEFAULT_RESPONSE_ERROR_MESSAGE } from 'modules/campaigns/lib/constants';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';
import { useDestinationsContext } from '../context';

export const deleteWebhookMutation = gql`
  mutation DeleteCampaignAlertsWebhookRequest($id: Long!) {
    deleteCampaignAlertsWebhook(id: $id)
  }
`;

export const useDeleteWebhook = (onComplete: () => void) => {
  const dispatch = useDispatch();
  const {
    savedWebhooks: { refetch },
  } = useDestinationsContext();

  const [deleteWebhook, { data, loading: isLoading, error }] = useMutation(deleteWebhookMutation, {
    onCompleted: () => {
      dispatch(addPositiveToast(`Webhook deleted successfully.`));
      onComplete();
      refetch();
    },
    onError: (e) => {
      const errorResponseMessage = maybeRestErrorMessage(e) || DEFAULT_RESPONSE_ERROR_MESSAGE;
      const errorMessage = `Cannot delete webhook: ${errorResponseMessage}`;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'useDeleteWebhook', e));
    },
  });

  return {
    deleteWebhook,
    data,
    isLoading,
    errorMessage: error?.message || data?.deleteCampaignAlertsWebhook?.failure?.message,
  };
};
